/* eslint-disable no-unused-vars */
import {Power1} from 'gsap';

import scroller from '../scroller';

const heading = document.querySelectorAll('.chapter__heading h3');

const reset = (node = heading) => {
	const tl = gsap.timeline();

	tl.set(node, {
		opacity: 0,
		y: 120,
		rotate: -5,
	});
};

const startAnimeLine = (node) => {
	gsap.to(node, {
		duration: 0.8,
		ease: Power1.easeInOut,
		clearProps: 'all',
		opacity: 1,
		y: 0,
		rotate: 0,
	});
};

const scrollTr = (clip) => {
	clip.forEach((clipCurrent) => {
		const startOffset = clipCurrent.clientHeight;

		gsap.from(clipCurrent, {
			scrollTrigger: {
				trigger: clipCurrent,
				start: `top-=${startOffset}px bottom`,
				once: true,
				// markers: {
				// 	startColor: 'red',
				// 	endColor: 'red',
				// },
				scroller: scroller.getElement(),
			},
			onStart() {
				startAnimeLine(clipCurrent);
			},
		});
	});
};

const subtitle = (parent) => {
	scrollTr(parent.querySelectorAll('.chapter__heading h3'));
};

const scrollTriggerTitle = (parent) => {
	const title = parent.querySelectorAll('.chapter__title');

	title.forEach((element) => {
		ScrollTrigger.create({
			trigger: element,
			start: 'top bottom',
			end: 'bottom top',
			toggleClass: 'animate',
			// markers: {
			// 	startColor: 'red',
			// 	endColor: 'red',
			// },
			scroller: scroller.getElement(),
		});
	});
};

reset(heading);

export {subtitle, scrollTriggerTitle};
